import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const CatalogPage = lazy(() => import('../pages/catalog/page'));
const ProductDetailPage = lazy(() => import('../pages/product-detail/page'));
const CollectionsPage = lazy(() => import('../pages/collections/page'));
const CollectionDetailPage = lazy(() => import('../pages/collection-detail/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/catalogo',
    element: <CatalogPage />,
  },
  {
    path: '/producto/:id',
    element: <ProductDetailPage />,
  },
  {
    path: '/colecciones',
    element: <CollectionsPage />,
  },
  {
    path: '/colecciones/:id',
    element: <CollectionDetailPage />,
  },
  {
    path: '/sobre-nosotros',
    element: <AboutPage />,
  },
  {
    path: '/contacto',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;